// 게임 분류 요청값만 변경하고 그 외 데이터는 유지한다.
export function normalizeSportsParams (params) {
  if (!params || typeof params !== 'object') return params
  const fields = ['category', 'gameCategory', 'groupCode', 'gameType', 'cateCode']
  if (!fields.some(field => params[field] === 'sport')) return params
  const result = { ...params }
  fields.forEach(field => { if (result[field] === 'sport') result[field] = 'sports' })
  return result
}
